import { Modal } from "components/Modal";
import { Button } from "components/Form/Button";

interface SaveProgressModalProps {
  show: boolean;
  onClose: () => void;
  onSave: () => void | Promise<void>;
  onDiscard: () => void | Promise<void>;
  busy?: boolean;
}

export function SaveProgressModal({
  show,
  onClose,
  onSave,
  onDiscard,
  busy = false,
}: SaveProgressModalProps) {
  return (
    <Modal show={show} onClose={onClose}>
      <div className="text-center space-y-6">
        <div className="space-y-3">
          <div className="text-2xl">📋</div>
          <h2 className="text-lg font-semibold text-gray-900">
            Save Your Progress?
          </h2>
          <p className="text-gray-600 text-sm">
            You have unsaved progress on this task. You can save your progress
            to continue later, or delete it to start over next time. Choose how
            you'd like to proceed before navigating to Homepage.
          </p>
        </div>

        <div className="space-y-3">
          <Button
            onClick={onSave}
            disabled={busy}
            className="w-full bg-3461fd hover:bg-3461fd/90"
          >
            <div className="flex items-center justify-center gap-2">
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              Save Progress
            </div>
          </Button>
          <button
            onClick={onDiscard}
            disabled={busy}
            className="w-full py-3 px-4 bg-red-50 hover:bg-red-100 text-red-700 hover:text-red-800 border border-red-200 hover:border-red-300 rounded-xl transition-colors text-sm font-medium"
          >
            <div className="flex items-center justify-center gap-2">
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
              Delete Progress
            </div>
          </button>
          <button
            onClick={onClose}
            disabled={busy}
            className="text-sm text-gray-500 hover:text-gray-700 transition-colors mt-1"
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
}
